module.exports = __webpack_public_path__ + "assets/img/6.374ef9c7.png";